package it.neckar.lizergy.model.location

import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface GeocodingResponse : RestResponse<MapCoordinatesInformation> {

  @Serializable
  @SerialName("good")
  data class Good(override val data: MapCoordinatesInformation) : GeocodingResponse, RestResponse.GoodResponse<MapCoordinatesInformation>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : GeocodingResponse, RestResponse.BadResponse<MapCoordinatesInformation>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: MapCoordinatesInformation): GeocodingResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): GeocodingResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: MapCoordinatesInformation?): GeocodingResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}

